export enum PlasticBagsForPackagingLabels {
  type = "type",
  dimensions = "dimensions",
  material = "material",
  print = "print",
}
